import { IFilters } from './components/filtersContainer'

export const GLOBAL_PARTNER_FORM_KEY = 'GLOBAL_PARTNER_FORM'

export const INITIAL_FILTERS: IFilters = {
  geoMappingsFilter: [],
  pbmFilter: [],
  productTreeFilter: [],
  partnerIdFilter: [],
  managerFilter: [],
}
